const EVENT_NAMES = {
  PAGE_VIEW: 'page_view',
  CTA_CLICK: 'cta_click',
  DEMO_FORM_STARTED: 'demo_form_started',
  DEMO_FORM_SUBMITTED: 'demo_form_submitted',
  DEMO_FORM_SUBMISSION_FAILED: 'demo_form_submission_failed',
  INSTANT_QUOTE_UPLOAD_STARTED: 'instant_quote_upload_started',
  INSTANT_QUOTE_UPLOAD_SUCCESS: 'instant_quote_upload_success',
  INSTANT_QUOTE_UPLOAD_FAILED: 'instant_quote_upload_failed',
  MODEL_VIEWER_OPENED: 'model_viewer_opened',
  MODEL_VIEWER_FAILED: 'model_viewer_failed',
  LANGUAGE_SWITCHED: 'language_switched',
  SCROLL_DEPTH: 'scroll_depth',
}

const ALLOWED = new Set(Object.values(EVENT_NAMES))

function getUtmParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    utm_source: params.get('utm_source') || undefined,
    utm_medium: params.get('utm_medium') || undefined,
    utm_campaign: params.get('utm_campaign') || undefined,
    utm_term: params.get('utm_term') || undefined,
    utm_content: params.get('utm_content') || undefined,
  }
}

export function trackEvent(eventName, payload = {}) {
  if (!ALLOWED.has(eventName)) {
    if (import.meta.env.DEV) {
      console.warn(`[analytics] blocked unknown event: ${eventName}`)
    }
    return
  }

  const eventPayload = {
    event: eventName,
    timestamp: new Date().toISOString(),
    path: window.location.pathname,
    ...payload,
  }

  if (window.gtag) {
    window.gtag('event', eventName, eventPayload)
  }

  if (window.plausible) {
    window.plausible(eventName, { props: eventPayload })
  }

  if (import.meta.env.DEV) {
    console.info('[analytics]', eventPayload)
  }
}

export function trackPageView({ pageName, locale }) {
  trackEvent(EVENT_NAMES.PAGE_VIEW, {
    page_name: pageName,
    locale,
    utm: getUtmParams(),
  })
}

export function analyticsEvents() {
  return EVENT_NAMES
}
